// extracted by mini-css-extract-plugin
export default {"stripWrapper":"styles_stripWrapper__2I0Uw"};